"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactApollo = require("react-apollo");

var _commonReact = require("@devsta/common-react");

var _ActiveCampaigns = _interopRequireDefault(require("../components/ActiveCampaigns"));

var _api = require("../../../../../../../common/api");

var _InspirationWrapper = require("../../../../../../../common/components/InspirationWrapper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ActiveCampaignsContainer(_ref) {
  var openViewPostModal = _ref.openViewPostModal,
      fetchAssets = _ref.fetchAssets,
      history = _ref.history;
  return _react.default.createElement(_InspirationWrapper.InspirationOrgConsumer, null, function (_ref2) {
    var selectedInspirationOrgId = _ref2.selectedInspirationOrgId;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        getAllActiveCampaigns: _api.getAllActiveCampaignsApi
      }
    }, function (_ref3) {
      var getAllActiveCampaigns = _ref3.getAllActiveCampaigns;
      return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apiClient) {
        return _react.default.createElement(_ActiveCampaigns.default, {
          getAllActiveCampaigns: getAllActiveCampaigns,
          organisationId: selectedInspirationOrgId,
          apiClient: apiClient,
          openViewPostModal: openViewPostModal,
          fetchAssets: fetchAssets,
          history: history
        });
      });
    });
  });
}

var _default = ActiveCampaignsContainer;
exports.default = _default;